"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const MapOl_vue_1 = __importDefault(require("../../Results/MapOlLocal/Components/MapOl.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const ProjectRate_1 = __importDefault(require("../class/models/ProjectRate"));
const RedirectionService_1 = __importDefault(require("../class/services/RedirectionService"));
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const MapLayer_1 = __importDefault(require("@becrop/components/MapBmk/models/MapLayer"));
const QrViewZero_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/QrViewZero.vue"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
let PreviewRate = class PreviewRate extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.redirectionService = new RedirectionService_1.default();
        // *********** NEW MAP CONFIG ***************
        this.mapLayer = new MapLayer_1.default({
            provider: this.vuedataSet.map_config.provider,
            key: this.vuedataSet.map_config.apikey,
        });
        this.MAP_CONTROLLER = new Controller_1.default();
        // *********** NEW MAP CONFIG ***************
    }
    viewResult() {
        this.redirectionService.open(this.project.previewData.resultUrl);
    }
    get vuedataSet() {
        return this.vuedata;
    }
    get imgSrc() {
        if (this.project.previewData.qrCode) {
            return `data:image/gif;base64,${this.project.previewData.qrCode}`;
        }
        else {
            return null;
        }
    }
    mounted() {
        this.MAP_CONTROLLER.create('map-dashboard', this.vuedataSet.map_config.provider, this.vuedataSet.map_config.apikey, '', '', '', 13, 0, 17);
        this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
            geoData: this.project.previewData.geodata,
            fillColor: this.project.crop.color + '50',
            strokeColor: this.project.crop.color,
            enableHoverInteraction: false,
            enableSelectInteraction: false,
            zoneName: `${this.project.name}-${this.project.proposal.id}`,
            centerZone: true,
            avg: 0,
            markers: [],
            preciseResult: false,
            modifyInteraction: false
        }));
    }
    updateMap() {
        this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
            geoData: this.project.previewData.geodata,
            fillColor: this.project.crop.color + '50',
            strokeColor: this.project.crop.color,
            enableHoverInteraction: false,
            enableSelectInteraction: false,
            zoneName: `${this.project.name}-${this.project.proposal.id}`,
            centerZone: true,
            avg: 0,
            markers: [],
            preciseResult: false,
            modifyInteraction: false
        }));
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new ProjectRate_1.default() })
], PreviewRate.prototype, "project", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], PreviewRate.prototype, "vuedata", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('project', { deep: true })
], PreviewRate.prototype, "updateMap", null);
PreviewRate = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapOl: MapOl_vue_1.default,
            GraphCertificateRate: bmk_ui_framework_1.GraphCertificateRate,
            Tag: bmk_ui_framework_1.Tag,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            DateStylized: bmk_ui_framework_1.DateStylized,
            QrViewZero: QrViewZero_vue_1.default,
            Button: bmk_ui_framework_1.Button
        },
    })
], PreviewRate);
exports.default = PreviewRate;
